import type { SaleClose } from "@/domain/activity/types";
import { saleClosesAt } from "@/domain/offer/series";
import { slotEnd } from "@/features/offers/slot-end";
import { formatDate } from "@/lib/time";

/** A template's sale-close offset is prefilled into the visible selling end, the
 *  way the lead time is into the start. Counted from the slot's end it needs the
 *  end typed too; until then the field stays empty rather than guessing one. */
export function templateSaleEndValue(
  day: Date,
  startTime: string,
  endTime: string,
  close: SaleClose | null,
): string {
  if (close === null || !startTime) return "";
  if (close.anchor === "end" && !endTime) return "";
  const dayText = formatDate(day, "yyyy-MM-dd");
  const startsAt = new Date(`${dayText}T${startTime}:00`);
  const endsAt = endTime ? slotEnd(dayText, startTime, endTime) : startsAt;
  const closesAt = saleClosesAt(startsAt, endsAt, close);
  return closesAt ? formatDate(closesAt, "yyyy-MM-dd'T'HH:mm") : "";
}
